import type { IPageItemsPayload } from '../types';

export interface IBreakdownItem<T extends string = string> {
  type: T;
  total: number;
}

const parseRawJson = (raw: unknown): unknown => {
  if (!raw) return undefined;
  return typeof raw === 'string' ? JSON.parse(raw) : raw;
};

export const parseJsonObject = <T extends object>(value: unknown): T | null => {
  try {
    const parsed = parseRawJson(value);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed as T;
  } catch {
    return null;
  }
};

export const parseJsonArray = <T>(raw: unknown): T[] | undefined => {
  try {
    const parsed = parseRawJson(raw);
    if (!Array.isArray(parsed)) return undefined;
    return parsed as T[];
  } catch {
    return undefined;
  }
};

export const parseBreakdownItems = <T extends string = string>(
  raw: unknown,
): IBreakdownItem<T>[] | undefined =>
  parseJsonArray<IBreakdownItem<T>>(raw)?.map((item) => ({ ...item, total: Number(item.total) }));

export const parsePageItems = (value: unknown): IPageItemsPayload | null =>
  parseJsonObject<IPageItemsPayload>(value);
